"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequestError = void 0;

var _react = require("react");

var _utils = require("../../../utils");

var _strings = require("../../../utils/strings");

var _services = require("../../../services");
/* eslint-disable react-hooks/exhaustive-deps */


var useRequestError = function useRequestError(productType, onRetry, error) {
  var productLabel = (0, _react.useMemo)(function () {
    return (0, _utils.getProductLabel)(productType);
  }, [productType]);

  var errorFormatter = function errorFormatter() {
    var errorValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, _strings.firstWordToLowerCase)(errorValue.toString());
  };

  (0, _react.useEffect)(function () {
    (0, _services.dispatchRequestErrorViewEvent)("".concat(productLabel, "_").concat(errorFormatter(error)));
  }, []);
  var handleRetryClick = (0, _react.useCallback)(function () {
    (0, _services.dispatchRetryRequestButtonClickEvent)(productLabel);
    onRetry();
  }, [productLabel, onRetry]);
  return {
    handleRetryClick: handleRetryClick
  };
};

exports.useRequestError = useRequestError;